// extracted by mini-css-extract-plugin
export default {"date":"DateView__date___e3a33"};